import React from 'react';
import ExportButton from './ExportButton';
import ImportButton from './ImportButton';

interface ExportImportButtonsProps {
  onExport?: () => void;
  onImport?: () => void;
  className?: string;
}

const ExportImportButtons: React.FC<ExportImportButtonsProps> = ({
  onExport,
  onImport,
  className = "flex flex-col sm:flex-row gap-3"
}) => {
  return (
    <div className={className}>
      {onExport && <ExportButton onExport={onExport} />}
      {onImport && <ImportButton onImport={onImport} />}
    </div>
  );
};

export default ExportImportButtons;
